import React, { useEffect, useState } from "react";
import { Button, FormLabel, FormElement, FormInput, CancelButton } from "../../../../../components/StyledElements";
import { updateSection } from "../../../../../services/courses";
import swal from "sweetalert2";


export const CoreDetails = ({ levelSection, style = {}, onSelectTab = () => { } }) => {
  const [updatedSection, setUpdatedSection] = useState(levelSection);
  const [currentSection, setCurrentSection] = useState(levelSection);
  const [savingSection, setSavingSection] = useState(false);

  useEffect(() => {
    setUpdatedSection(levelSection);
    setCurrentSection(levelSection);
  }, [levelSection]);

  const hasChanged = () => {
    return JSON.stringify(updatedSection) !== JSON.stringify(currentSection);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <div style={{ position: "absolute", top: 20, right: 20, display: "flex", zIndex: 200, flexDirection: "row", gap: "10px" }}>
        <CancelButton onClick={() => {
          swal.fire({
            title: "Are you sure?",
            text: "Any unsaved changes will be lost.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, cancel",
            cancelButtonText: "No, keep editing",
          }).then((result) => {
            console.log("!!! RESULT: ", result);
            if (result?.value) {
              setUpdatedSection(currentSection);
            }
          });
        }}>Cancel</CancelButton>
        <Button disabled={!hasChanged() || savingSection} style={{ marginLeft: "auto" }}
          onClick={async () => {
            if (!hasChanged()) {
              return;
            }


            // open a sweetalert2 modal until the save is complete
            swal.fire({
              title: "Saving...",
              text: "Please wait while the level is being saved.",
              allowOutsideClick: false,
              didOpen: () => {
                swal.showLoading();
              },
            });

            setSavingSection(true);
            const results = await updateSection(updatedSection);
            setSavingSection(false);

            if (results.success) {
              //const newUpdatedBlock = results.content_block;
              setCurrentSection(updatedSection);
              swal.fire({
                title: "Success",
                text: "Section block saved successfully.",
                icon: "success",
              });
            } else {
              swal.fire({
                title: "Error",
                text: results.error || "An error occurred while saving the level.",
                icon: "error",
              });
            }
          }}
        >
          {savingSection ? "Saving Section..." : "Save Section"}
        </Button>
      </div>
      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={levelSection?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Title" />
        <FormInput type="text" placeholder="Enter level section title" value={updatedSection?.title ?? ""}
          onChange={(e) => {
            setUpdatedSection({ ...updatedSection, title: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter description"
          style={{ resize: "vertical" }}
          value={updatedSection?.description ?? ""}
          onChange={(e) => {
            setUpdatedSection({ ...updatedSection, description: e.target.value });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Short Description" />
        <FormInput
          as="textarea"
          rows={2}
          placeholder="Enter short description"
          style={{ resize: "vertical" }}
          value={updatedSection?.short_description ?? ""}
          onChange={(e) => {
            setUpdatedSection({ ...updatedSection, short_description: e.target.value });
          }}
        />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
